var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5544_51692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00067171 8.46533C0.446024 8.46533 0.887015 8.55206 1.29847 8.72056C1.70992 8.88905 2.08378 9.13603 2.39868 9.44739C2.7136 9.75873 2.9634 10.1284 3.13383 10.5352C3.30425 10.942 3.39198 11.378 3.39198 11.8183C3.39198 12.2586 3.30425 12.6946 3.13383 13.1014C2.96339 13.5081 2.7136 13.8779 2.39868 14.1891C2.08378 14.5005 1.70992 14.7475 1.29847 14.916C0.887015 15.0845 0.446024 15.1712 0.000671387 15.1712",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0007 15.1712C25.5553 15.1712 25.1143 15.0845 24.7029 14.916C24.2915 14.7475 23.9176 14.5005 23.6027 14.1891C23.2877 13.8779 23.0379 13.5081 22.8676 13.1014C22.6971 12.6946 22.6094 12.2586 22.6094 11.8183C22.6094 11.378 22.6971 10.942 22.8676 10.5352C23.0379 10.1284 23.2877 9.75873 23.6027 9.44739C23.9176 9.13603 24.2915 8.88905 24.7029 8.72056C25.1143 8.55206 25.5553 8.46533 26.0007 8.46533",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8702 6.00642H1.13111C1.00624 6.00642 0.905019 6.1065 0.905019 6.22995V9.02407H0.000671387V6.22995C0.000671387 5.61269 0.506785 5.1123 1.13111 5.1123H24.8702C25.4946 5.1123 26.0007 5.61269 26.0007 6.22995V9.02407H25.0963V6.22995C25.0963 6.1065 24.9951 6.00642 24.8702 6.00642ZM25.0963 14.6123V17.4064C25.0963 17.5299 24.9951 17.6299 24.8702 17.6299H1.13111C1.00624 17.6299 0.905019 17.5299 0.905019 17.4064V14.6123H0.000671387V17.4064C0.000671387 18.0237 0.506784 18.524 1.13111 18.524H24.8702C25.4946 18.524 26.0007 18.0237 26.0007 17.4064V14.6123H25.0963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.142 1.11989L1.25662 5.63048C1.13646 5.65643 1.05524 5.77325 1.07293 5.89305L0.18936 6.08388C0.0876263 5.4773 0.496251 4.88046 1.10437 4.74912L21.9898 0.238527C22.5997 0.1068 23.1794 0.493258 23.2844 1.10171L24.041 5.48107L23.1575 5.67188L22.401 1.29252C22.38 1.17083 22.264 1.09354 22.142 1.11989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9306 2.86557C17.9727 3.10895 18.2045 3.26354 18.4486 3.21084C18.6926 3.15816 18.8562 2.91814 18.8142 2.67476L17.9306 2.86557ZM17.6452 1.21302L17.9306 2.86557L18.8142 2.67476L18.5288 1.02222L17.6452 1.21302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6348 6.7059C17.6348 6.9528 17.8372 7.15296 18.0869 7.15296C18.3367 7.15296 18.5391 6.9528 18.5391 6.7059H17.6348ZM17.6348 5.58826V6.7059H18.5391V5.58826H17.6348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5398 16.7647C18.5398 16.5178 18.3373 16.3176 18.0876 16.3176C17.8379 16.3176 17.6354 16.5178 17.6354 16.7647H18.5398ZM18.5398 17.8823V16.7647H17.6354V17.8823H18.5398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0876 11.1765V8.94116",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0876 15.647V13.4117",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78333 8.46533H9.0442",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78333 10.7006H14.6964",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78333 12.9359H14.6964",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78333 15.1711H14.6964",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5544_51692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.00530b12ed34c7a9a54f3aceeaeef9d8.svg";
export { ForwardRef as ReactComponent };